exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdl-dialog__title {\n  font-size: 18px;\n  font-weight: 300;\n  color: #949494;\n  padding-top: 0;\n}\n\n.add-filter-label {\n  margin-right: 10px;\n}\n\n", ""]);

// exports
